import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Rating from "@material-ui/lab/Rating";
import Avatar from "@material-ui/core/Avatar";

const BlogPosts = ({ blog, quantityInRow }) => {
  const className = () => {
    let col = 12 / quantityInRow;
    return `col-md-${col}`;
  };
  return (
    <section className="pb-3 text-left">
      <div className="row">
        {blog.map((blog, index) => (
          <div key={index} className={className()}>
            <div className="card promoting-card px-0 mb-4 hoverable">
              <div className="card-body d-flex flex-row align-items-center pr-0 pl-2 py-3">
                <Avatar
                  alt={blog.author}
                  src="https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/users%2FBd3o0M0o1YUKVVoczU1AAkodnRO2.jpeg?alt=media&token=3cfce532-e352-4458-8e00-c7c07ec97ea3"
                  className="mr-2"
                  style={{ width: "65px", height: "65px" }}
                />

                <div style={{ overflow: "hidden" }}>
                  <h4
                    className="card-title font-weight-bolder mb-0"
                    style={{ fontSize: "1.25rem" }}
                  >
                    {blog.title}
                  </h4>
                  <h6 className="font-small mb-0">{blog.author}</h6>

                  <p className="card-text">
                    <i className="far fa-clock pr-2"></i>
                    {blog.createdDate}
                  </p>
                </div>
              </div>
              <div className="card-img-box">
                <img
                  className="card-img-top rounded-0"
                  src={blog.imageUrl}
                  alt={blog.title}
                />
              </div>

              <div className="card-body">
                <Rating
                  size="small"
                  defaultValue={blog.ratings.value}
                  precision={0.5}
                  readOnly
                />
                <span
                  className="mr-3"
                  style={{ verticalAlign: "text-bottom" }}
                >{`${blog.ratings.value} (${blog.ratings.count})`}</span>
                <Button
                  style={{ borderRadius: 50, verticalAlign: "middle" }}
                  size="small"
                  variant="outlined"
                >
                  {blog.category.name}
                </Button>
                <hr className="mb-4" />
                <p
                  className="card-text"
                  style={{ height: "4rem", overflow: "hidden" }}
                >
                  {blog.description}
                </p>
                <Link
                  className="btn btn-flat red-text p-1 my-1 mr-0 mml-1"
                  to={`/blog/post/${blog.id}`}
                >
                  READ MORE
                </Link>
                <i
                  className="fas fa-share-alt text-muted float-right p-1 my-1"
                  data-placement="top"
                  title="Share this post"
                ></i>
                <i
                  className="far fa-comments text-muted float-right p-1 mr-3 my-1"
                  data-placement="top"
                  title="Comments"
                >
                  {" "}
                  0
                </i>
                <i
                  className="fas fa-heart text-muted float-right p-1 my-1 mr-3"
                  data-placement="top"
                  title="
                  I like it"
                >
                  {` ${blog.likes.length}`}
                </i>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogPosts;
